const enum MEASURE_TYPE {
  CM = "cm",
  FT = "ft",
}

export default MEASURE_TYPE;
